class geoDealers {
	constructor() {
		// localStorage.removeItem('userAddress');
		var userAddress = localStorage.getItem('userAddress');
		this.initGeo(userAddress);
		this.runGeo = true;
	}

	initGeo(userAddress) {
		var _this = this;
		// If there is no address cached - find the address
 		if (!userAddress || userAddress =='' || typeof userAddress == undefined || userAddress == null) {
			this.addressLookUp(function() {
				userAddress = localStorage.getItem('userAddress');

				_this.dealersProcess(userAddress);
		
			});
		// If there is an address cached
 		} else {
 			// var formExists = setInterval(geo.dealersProcess(userAddress, formExists), 100);
 			console.log(userAddress + ' - Address found!');
 			$(document).ready(function() {
 				console.log('Ready...');
 				// $(document).on('nfFormReady', function ( e, layoutView ) {
 				// 	console.log('Form is ready');
 					_this.dealersProcess(userAddress);
 				// });
 			});
 			
 		}
	}

	// Dealers Process: Steps to load dealers and assign correct values to geo inputs 
	dealersProcess (userAddress) {
		var _this = this;

	    if (typeof google === "undefined" || !google.maps) {
	        // Try again in 500ms until Google loads
	        setTimeout(function() {
	            _this.dealersProcess(userAddress);
	        }, 500);
	        return;
	    }

		if ($(".nf-form-layout").length > 0) {
			if ($('.geolocation').length > 0) {

				var input = $('.geolocation')[0];
				var autocomplete = new google.maps.places.Autocomplete(input, {
									    componentRestrictions: { country: ["us", "ca"] },
									    fields: ["address_components", "formatted_address"],
									    types: ["address"],
									  });
				google.maps.event.addListener(autocomplete, 'place_changed', function () {
				        // If getPlace() is not undefined (so if it exists), store the formatted_address (or whatever data is relevant to you) in the hidden input.
				        if(autocomplete.getPlace() !== undefined) {
				            $('.geolocation').val(autocomplete.getPlace().formatted_address).trigger('change');
				        	var evt = document.createEvent("HTMLEvents");
				        	evt.initEvent("change", true, true);
				        	$('.geolocation')[0].dispatchEvent(evt);
				        }
				    });

				_this.assignAddressToInput(userAddress);
		    	
		    	// Find Dealers Page
		    	if ($('.find-dealer-submit').length > 0 || $('[data-load-dealers]').length > 0) {
		    		var point = JSON.parse(localStorage.getItem('userLatLng'));
		    		var number = $('[data-load-dealers]').length > 0 ? 3 : -1; // Load only 3 dealers for single product template
		    		var dealersNumber = $('[data-dealers-number]').data('dealers-number');
		    		var threshold = $('[data-threshold]').length > 0 ? $('[data-threshold]').data('threshold') : 99999;

		    		_this.loadDealers(point, number, dealersNumber, threshold);
		    	} else {
		    		// Other pages with quotes
		    		// TODO: Check funcionality for other pages
		    		_this.matchDealertoAddress(point);
		    	}
		    }
		  
		} else {
			setTimeout(function() {_this.dealersProcess(userAddress)}, 1000);
		}
	}

	// Find Current User Address - first time only, if there is no cached value
	addressLookUp(callback) {
 	    $.ajax({
 	        type : 'POST',
 	        data: '', 
 	        url: "https://www.googleapis.com/geolocation/v1/geolocate?key=" + googleAPI, 
 	        success: function(result){
 	            var latitude = result['location']['lat'];
 	            var longitude = result['location']['lng'];
 	            var point = { lat: latitude, lng: longitude };
 	            var userAddress;

 	            new google.maps.Geocoder().geocode({ location : point }, function (res, status) {
 	                if (status == google.maps.GeocoderStatus.OK && typeof res[0] !== 'undefined') {
 	                    
 	                    for(var elmIdx in res)
	 	             	{
     		             	if(res[elmIdx].formatted_address.length > 0 && res[elmIdx].types.indexOf("plus_code") == -1)
     		             	{
     			             	userAddress = res[elmIdx].formatted_address;
     			             	break;
     		             	}
	 	             	}
	             		localStorage.setItem('userAddress', userAddress);
	             		localStorage.setItem('userLatLng', JSON.stringify(point));

	             		console.log(localStorage.getItem('userAddress'));

	             		// Assign New Values to inputs and save primary dealer
	             		callback();
	 	                
	 	            } else {
	 	                console.log('Google maps error: ' + status + '. Please try again later.');
	 	            }
 	                    
 	            });

 	        }, 
 	        error: function(xhr, status, error) {
 	        	var err = JSON.parse(xhr.responseText);
 	            console.log('Unable to find your location. Ajax error. ' + err + ' | ' + status + ' | ' + error);
 	        }
 	    });
	}

	// Find user's coordinates based on the address input
	geocodeUserAddress (userAddress, loadDealers = true ) {
		var geocoder = new google.maps.Geocoder();
		var _this = this;

		geocoder.geocode( { 'address': userAddress}, function(results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
			    var latitude = results[0].geometry.location.lat();
			    var longitude = results[0].geometry.location.lng();
			    var point = { lat: latitude, lng: longitude };

			    userAddress = results[0].formatted_address;

			    localStorage.setItem('userAddress', userAddress);
			    localStorage.setItem('userLatLng', JSON.stringify(point));
			    _this.runGeo = false;
			    $('.geolocation').val(userAddress).trigger('change');

			    if (loadDealers) {
			    	var number = $('[data-load-dealers]').length > 0 ? 3 : -1;
			    	var dealersNumber = $('[data-dealers-number]').data('dealers-number');
			    	var threshold = $('[data-threshold]').length > 0 ? $('[data-threshold]').data('threshold') : 99999;

			    	_this.loadDealers(point, number, dealersNumber, threshold);
			    } else {
			    	_this.matchDealertoAddress(point);
			    }
			    
		    } 
		}); 
	}

	// Find an input with class .geolocation and assign user postal code
	assignAddressToInput(userAddress) {
		var input = $('.geolocation')[0];
      	$('.geolocation').val(userAddress).trigger( 'change' );
	    // trigger event change the hard way - no other way works!!!
	    var evt = document.createEvent("HTMLEvents");
	    evt.initEvent("change", true, true);
	    input.dispatchEvent(evt);
	}


	// Find all dealers associated with user address
	loadDealers(point, number = -1, dealersNumber = -1, threshold = 9999) {

		$.ajax({
		  method: 'POST',
		  url: ajax_url,
		  type: 'JSON',
		  data: {
		    point: point,
		    number: number,
		    dealers_number : dealersNumber,
		    threshold : threshold,
		    action: 'load_dealers',
		  },
		  success: res => this.renderDealers(res),
		  error: function (request, status, error) {
		          console.log(request.responseText);
		      }
		});
	}

	// Display dealers' HTML
	renderDealers({dealers, extra, message, wrapper}) {
		if ($('#dealer-results').length) {
		  $('#dealer-results').empty();
		  $('.dealers-message').remove();
		  $('#dealer-more-info .more-info-content').empty();
		  $('.fallback-form').hide();
		} else {
		  $('.find-dealer-submit').parents('.nf-form-cont').after('<div id="dealer-results" class="wp-block-columns"></div>');
		}

		if (dealers.length > 0) {
		  	for (var i = dealers.length - 1; i >= 0; i--) {
			    $('#dealer-results').prepend(dealers[i]);

			    if (message != '' && $('.dealers-message').length == 0) {
			    	$('#dealer-results').before('<div class="dealers-message">'+ message + '</h4>');
			    }
			    
			    $('#dealer-more-info .more-info-content').prepend(extra[i]);

			    if (message != '') {
			    	$('.fallback-form').fadeIn();
			    }
		  	}

		  	if (wrapper && dealers.length > 1) {

		  		if ($('#dealer-results').hasClass('slick-initialized')) {
		  		  $('#dealer-results').slick('unslick');
		  		}

		  		$('#dealer-results').addClass('js-slider');

	  			if (!$('.clickable.focused').length) {

	  			    $('.product-request-quote .nf-next').prop('disabled', true);

	  			    // Ninja Forms error handling — find the right field to target
	  			    const $errorField = $('.nf-field:has(#dealer-results)'); // or dealername, depending

	  			    // Add error class and message
	  			    if (!$errorField.find('.nf-error-msg').length) {
	  			      $errorField.addClass('nf-error');
	  			      $errorField.find('.nf-field-element').after('<div class="nf-error-msg">Please select a contractor from whom you would like to request a quote.</div>');
	  			    }
	  			    
	  			}
		  		
		  	} else {
		  		if ($('#dealer-results').hasClass('slick-initialized')) {
		  		  $('#dealer-results').slick('unslick');
		  		  $('#dealer-results').removeClass('js-slider');
		  		}
		  	}

		  setTimeout(function() {
		    $('.js-slider').not('.slick-initialized').slick({
		        slidesToScroll: 1,
		        slidesToShow: 1.2,
		        arrows: false,
		        dots: true,
		        infinite: false,
		        mobileFirst: true,
		        variableWidth: false,
		        rows: 0,
		        responsive: [
		            {
		              breakpoint: 600,
		              settings: {
		                slidesToShow: 1.5,
		                slidesToScroll: 1,
		              }
		            },
		            {
		              breakpoint: 800,
		              settings: {
		                arrows: true,
		                slidesToShow: 1.75,
		                slidesToScroll: 1,
		                arrows: true,
		              }
		            }
		          ]
		    });
		  }, 600);

		} else {
			if (message != '' && $('.dealers-message').length == 0) {
				$('#dealer-results').before('<div class="dealers-message">'+ message + '</h4>');
			}
			if ($('.fallback-form').length) {
				$('.fallback-form').fadeIn();
			} else {
				var point = JSON.parse(localStorage.getItem('userLatLng'));
				this.matchDealertoAddress(point);

				const $errorField = $('.nf-field:has(#dealer-results)');

				$errorField.removeClass('nf-error');
				$errorField.find('.nf-error-msg').remove();
			}

			$('.product-request-quote .nf-next').prop('disabled', false);

		}
	}

	matchDealertoAddress(point = JSON.parse(localStorage.getItem('userLatLng'))) {
		var local = [];
		var _this = this;

 		$.ajax({
		  method: 'POST',
		  url: ajax_url,
		  type: 'JSON',
		  data: {
		    point: point,
		    action: 'find_local_dealer',
		  },
		  success: localDealer => _this.assignLocalDealerInputs(localDealer),
		  error: function (request, status, error) {
		          console.log(request.responseText);
		      }
		});

	}

	assignLocalDealerInputs(localDealer) {

 		var dealer = localDealer.name;
 		var email = localDealer.email;

 		var dealerInput = $('[data-key=dealername]')[0];
 		var dealerEmailInput = $('[data-key=dealeremail]')[0];

		$('[data-key=dealername]').val(dealer).trigger( 'change' );
		$('[data-key=dealeremail]').val(email).trigger( 'change' );

		// trigger event change the hard way - no other way works!!!
		var evt = document.createEvent("HTMLEvents");
		evt.initEvent("change", true, true);
		dealerInput.dispatchEvent(evt);
		dealerEmailInput.dispatchEvent(evt);

		console.log(dealer + ' | ' + email);	 	
	}
}
export default geoDealers;